import React, { Component } from "react";
import Navbar from "../navbar/navbar";
import "./keynotes.css";
import "../home/home.css";
import keynotes from "./keynotes.json";
class Keynotes extends Component {
  render() {
    return (
      <>
        <div className="header-area">
          <div id="home" className="contact-header-area  bg_cover">
            <Navbar />
            <div className=" d-flex align-items-center">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-10">
                    <div className="header-content text-center">
                      <h2 className="header-title2">Key Note Speakers</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>          
          </div>
        </div>
        
        <div class="schedule-timeline">
          {keynotes &&
            keynotes.map((k, key) => {
              let even = false;
              if ((key + 1) % 2 == 0) even = true;
              return (
                <div class={`schedule-block ${even ? "even" : ""}`}>
                  <div class="inner-box">
                    <div class="inner">
                      <div class="date">
                        {k?.from} <br /> {k?.to}
                      </div>
                      <div class="speaker-info">
                        <figure class="thumb">
                          <img src={k?.img} alt="" />
                        </figure>
                        <h6 class="name">{k?.speaker_name}</h6>
                        <span class="designation">{k?.designation}</span>
                      </div>
                      <p className="mob-date">{`${k?.from} - ${k?.to}`}</p>
                      <h4>
                        <p>{k?.topic}</p>
                      </h4>
                      <div class="text">{k?.short_desc}</div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div> 
      </>
    );
  }
}

export default Keynotes;
